class PuzzleRandomizer {

    static getRandomElement(arr) {
        return arr[Math.floor(Math.random() * arr.length)];
    }

    static generateUniqueValues(count, max) {
        if (count > max) {
            throw new Error('Count cannot be greater than max');
        }
    
        const values = new Set();
        while (values.size < count) {
            values.add(Math.floor(Math.random() * max));
        }
        return Array.from(values);
    }

    static generateUniquePatterns(count, pattern = null) {
        const patterns = 'ABCDEF'.split('');
        const shuffled = patterns.sort(() => 0.5 - Math.random());
        if (pattern) {
            const index = shuffled.indexOf(pattern);
            shuffled.splice(index, 1);
            shuffled.unshift(pattern);
        }
        return shuffled.slice(0, count);
    }

    static generateCorrectInput(rule, spots, patterns) {
        switch (rule) {
            case 'smallToBig':
                return spots.slice().sort((a, b) => a - b);
            case 'bigToSmall':
                return spots.slice().sort((a, b) => b - a);
            case 'reverseOrder':
                return spots.slice().reverse();
            default:
                if (rule.startsWith('locatePattern')) {
                    const pattern = rule.replace('locatePattern', '');
                    return spots.filter((_, index) => patterns[index] === pattern);
                }
                return [];
        }
    }

    static generatePuzzle(randomizedPuzzleConfig, randomizedPuzzleLocationConfig, ruleIndex) {

        return randomizedPuzzleConfig.map((config, index) => {
            const location = PuzzleRandomizer.getRandomElement(randomizedPuzzleLocationConfig);
            const sequenceLength = config.sequence[0].length;
            const spots = PuzzleRandomizer.generateUniqueValues(sequenceLength, 7);

            

            

            
            const selectedRules = config.randomizedRules[ruleIndex];
            const ruleId = PuzzleRandomizer.getRandomElement(selectedRules);

            const correctOrderRequired = ['smallToBig', 'bigToSmall', 'reverseOrder'].includes(ruleId);

            var requiredPattern = null;
            if(ruleId.startsWith('locatePattern')) {
                requiredPattern = ruleId.replace('locatePattern', '');
            } 
            const patterns = PuzzleRandomizer.generateUniquePatterns(sequenceLength, requiredPattern);
                

            const sequence = config.sequence.map(seq => 
                seq.map((item, idx) => ({
                    spot: spots[idx],
                    variation: {
                        ...item.variation,
                        pattern: patterns[idx]
                    }
                }))
            );


            const correctInput = sequence.map(seq => 
                PuzzleRandomizer.generateCorrectInput(ruleId, seq.map(item => item.spot), seq.map(item => item.variation.pattern))
            );

            return {
                _comment: config._comment,
                location,
                time: config.time,
                allowFail: config.allowFail,
                successFeedback: config.successFeedback,
                sequence,
                rule: {
                    id: [ruleId],
                    correctInput,
                    correctOrderRequired
                }
            };
        });
    }
}
module.exports = PuzzleRandomizer;